import CategoryFilter from "@/components/gallery/CategoryFilter";

interface GalleryHeaderProps {
  language: string;
  categories: string[];
  selectedCategory: string | null;
  onSelectCategory: (category: string | null) => void;
}

const GalleryHeader = ({ language, categories, selectedCategory, onSelectCategory }: GalleryHeaderProps) => {
  return (
    <div className="relative bg-gray-100 overflow-hidden">
      {/* Background image — add src here when the banner image is ready */}
      <div className="absolute inset-0">
        {/* <img
          src=""
          alt="Gallery Banner"
          className="w-full h-full object-cover"
          loading="eager"
        /> */}
      </div>

      <div className="relative container mx-auto px-4 sm:px-6 lg:px-8 pt-40 pb-24">
        <div className="text-center">
          <h1 className="text-4xl sm:text-5xl font-bold text-[#1A1F2C] mb-6 animate-fade-up [animation-delay:200ms]">
            {language === 'KO' ? '비즈니스 이벤트 및 글로벌 활동' : 'Our Business Events & Global Presence'}
          </h1>
          <p className="text-xl text-[#403E43] max-w-2xl mx-auto mb-2 animate-fade-up [animation-delay:400ms]">
            {language === 'KO'
              ? '비즈니스 서밋, 파트너십, 기업 이정표를 통한 우리의 여정을 살펴보세요. Duru Compliance가 인도에서 글로벌 확장의 미래를 어떻게 형성하고 있는지 확인하세요.'
              : 'Explore our journey through business summits, partnerships, and corporate milestones. See how Duru Compliance is shaping the future of global expansion in India.'}
          </p>

          {/* Category filter badges — in header so users reach content immediately */}
          <div className="max-w-2xl mx-auto">
            <CategoryFilter
              categories={categories}
              selectedCategory={selectedCategory}
              onSelectCategory={onSelectCategory}
              language={language}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GalleryHeader;